<template>
  <v-container fill-height justify-content-start :class="{'pa-2': $vuetify.breakpoint.xsOnly}" class="app-section-width">
    <v-layout column>
      <v-toolbar color="white" flat>
        <v-btn icon light @click="exit()">
          <v-icon color="grey darken-2">mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title class="grey--text text--darken-4 pa-0">{{ $t('headers.guest') }}</v-toolbar-title>
      </v-toolbar>
      <v-flex class="app-scroll-section">
        <v-text-field
          v-if="name !== null"
          :label="$t('fields.name')"
          :value="name"
          outlined
          readonly
          class="mt-4"
        ></v-text-field>
        <v-text-field
          v-if="surname !== null"
          :label="$t('fields.surname')"
          :value="surname"
          outlined
          readonly
        ></v-text-field>
        <v-text-field
          v-if="phone !== null"
          :label="$t('fields.phone')"
          :value="phone"
          outlined
          readonly
        ></v-text-field>
        <v-text-field
          v-if="email !== null"
          :label="$t('fields.email')"
          :value="email"
          outlined
          readonly
        ></v-text-field>
        <div v-for="(document, i) in documents" :key="i">
          <v-text-field
            v-if="document.number"
            :label="$t('document_type.' + documentType(document))"
            :value="document.number"
            outlined
            readonly
          ></v-text-field>
        </div>
        <v-text-field
          v-if="birthdate !== null"
          :label="$t('fields.birthdate')"
          :value="birthdate"
          outlined
          readonly
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { displayFormatDate } from '@/lib/helpers/DateUtils'
import routeNames from '../router/routes'
import router from '@/router'
import moment from 'moment'

export default {
  methods: {
    exit () {
      router.push({ name: routeNames.booking.name })
    },
    documentType (document) {
      return document && document.type ? document.type.toUpperCase() : 'ID_CARD'
    },
  },
  computed: {
    id () {
      return this.$route.params.guestId
    },
    bookingId () {
      return this.$route.params.bookingId
    },
    guest () {
      if (this.$store.state.me.bookings === null) {
        return []
      }

      let id = this.id
      let guest = null
      let guests = this.$store.state.me.bookings.find((b) => { return b.booking.id === this.bookingId }).guests

      guests.forEach((item, i) => {
        if (item.guest.id === id) {
          guest = item
        }
      })

      return guest
    },
    name () {
      return this.guest && this.guest.profile ? this.guest.profile.name : null
    },
    surname () {
      return this.guest && this.guest.profile ? this.guest.profile.lastName : null
    },
    phone () {
      return this.guest && this.guest.profile && this.guest.profile.phoneNumber ? this.guest.profile.phoneNumber : null
    },
    email () {
      return this.guest && this.guest.profile && this.guest.profile.email ? this.guest.profile.email : null
    },
    birthdate () {
      return this.guest && this.guest.profile && this.guest.profile.dateOfBirth ? displayFormatDate(moment.utc(this.guest.profile.dateOfBirth), 'xl', true) : null
    },
    documents () {
      return this.guest && this.guest.profile && this.guest.profile.documents ? this.guest.profile.documents : []
    },
  },
  created () {
    if (this.$store.state.me.bookings === null) {
      this.$store.dispatch('me/getBookings')
    }
  },
}
</script>

<style lang="scss">
</style>
